<div class="save-link">
  <a *ngIf="!isSaved()" (click)="saveCover(false)"><i nz-icon type="star"></i>Save this Market</a>
  <a *ngIf="isSaved()" (click)="saveCover(true)">
    <i nz-icon type="star" theme="fill" style="color:#f1c400;"></i>Saved
  </a>
</div>
